import { Suspense } from 'react';
import { createRoot } from 'react-dom/client';
import '@design-system/sass/main.scss';
import App from './App';
import { asyncWithLDProvider } from 'launchdarkly-react-client-sdk';
import { initCSPReporting } from './utils/csp';

// Initialize CSP violation reporting
initCSPReporting();

(async () => {
  const LDProvider = await asyncWithLDProvider({
    clientSideID: window.FN_CONFIG.FEATUREFLAGS_CLIENT_SIDE_KEY,
    context: {
      kind: 'user',
      // Keep bootstrap identity stable so repeated app loads do not create new anonymous MAUs.
      key: 'cobalt-bootstrap-user-FN',
    },
    reactOptions: {
      useCamelCaseFlagKeys: false,
    },
  });
  createRoot(document.getElementById('root')!).render(
    <LDProvider>
      <Suspense fallback={null}>
        <App />
      </Suspense>
    </LDProvider>
  );
})();
